import { useState } from "react";
import TspApiService from "../../api/tspApiService";
import useTspApiResource from "../../hooks/useTspApiResource";

export const VISITS_PAGE_SIZE = 20;
const NOTHING = () => Promise.resolve({ data: null });

// Everything the City Visits screen needs, from the API: the journeys that are
// in progress (visits are only recorded while one is), the chosen journey's route
// cities, and the page of recorded visits. Each part loads independently.
//
// `editVisitId` (an "Update Visit" link): that one visit is also loaded by id,
// since it need not be on the current page of the history.
export default function useTspCityVisitsData({ initialJourneyId, editVisitId }) {
  const [journeyId, setJourneyId] = useState(initialJourneyId || "");
  const [page, setPage] = useState(1);

  const journeys = useTspApiResource(() => TspApiService.listJourneys({ status: "IN_PROGRESS", sort: "journey_name", order: "asc", limit: 100 }), []);
  const route = useTspApiResource(() => (journeyId ? TspApiService.getRoute(journeyId) : NOTHING()), [journeyId]);
  const visits = useTspApiResource(() => TspApiService.listCityVisits({ page, limit: VISITS_PAGE_SIZE }), [page]);
  const editTarget = useTspApiResource(() => (editVisitId ? TspApiService.getCityVisit(editVisitId) : NOTHING()), [editVisitId]);

  return { journeyId, setJourneyId, page, setPage, journeys, route, visits, editTarget };
}
